import { ErrorBoundary } from 'react-error-boundary';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PageTransition } from './layout/PageTransition';
import AdminPanel from './pages/AdminPanel';
import ContactForm from './pages/ContactForm';
import CustomerPortal from './pages/CustomerPortal';
import DatePage from './pages/Date';
import Home from './pages/Home';
import Login from './pages/Login';
import MarginDemo from './pages/MarginDemo';
import SubmissionSuccess from './pages/SubmissionSuccess';
import SupplierPortal from './pages/SupplierPortal';
import WeddingFairContact from './pages/contact/weddingfair';
import Gallery from './pages/gallery';

function ErrorFallback({error}: {error: Error}) {
  return (
    <div role="alert" className="p-4 text-red-500">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="app min-h-screen min-w-[360px] bg-white text-black">
        <Router>
          <Routes>
            <Route path="/" element={
              <div className="min-h-screen min-w-[360px]">
                <ErrorBoundary FallbackComponent={ErrorFallback}>
                  <PageTransition>
                    <Home />
                  </PageTransition>
                </ErrorBoundary>
              </div>
            } />
            <Route path="/gallery" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <Gallery />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/contactform" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <ContactForm />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/contact/weddingfair" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <WeddingFairContact />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/date" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <DatePage />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/login" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <Login />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/admin" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <AdminPanel />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/supplier" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <SupplierPortal />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/customer" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <CustomerPortal />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/margin-demo" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <MarginDemo />
                </PageTransition>
              </ErrorBoundary>
            } />
            <Route path="/submission-success" element={
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageTransition>
                  <SubmissionSuccess />
                </PageTransition>
              </ErrorBoundary>
            } />
          </Routes>
        </Router>
      </div>
    </ErrorBoundary>
  );
} 